import ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import { getStore } from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';
import getActiveTabId from './getActiveTabId';

export default function getItemReadingPaneViewState(itemId?: string): ItemReadingPaneViewState {
    if (isFeatureEnabled('rp-persistedReadingPaneTabs')) {
        return getStore().loadedItemReadingPaneViewStates.get(
            itemId ? itemId : getCurrentRenderedItemId()
        );
    }
    return getStore().itemReadingPaneViewState;
}

function getCurrentRenderedItemId(): string {
    // If SxS is displayed, this should be considered the current rendered item
    // Otherwise go with the active tab id
    return getStore().sxsId ? getStore().sxsId : getActiveTabId();
}
